export default __webpack_public_path__ + "static/media/lining3.037632cb.jpeg";